import { MiniGameType } from '../interfaces/mini-game.interface';

/**
 * Canonical skill a game measures — the single source of truth for the
 * `skill` (and `grade`) properties on the shared `gameWorld-round`
 * skill-analytics event. Using one stable slug per game lets the Amplitude
 * dashboard group cleanly across games (e.g. "how are students doing on
 * add-subtract-fractions across every game that teaches it").
 *
 * Add an entry here whenever a game is instrumented (new games via the
 * ig-* studio pipeline, existing games via Architect Mode B). See
 * ig-game-theme.md §3 (Skill analytics rule).
 */
export interface GameSkillMeta {
  /** Stable kebab-case skill slug for dashboard grouping. */
  skill: string;
  /** Optional curriculum standard code, if one applies. */
  standard?: string;
  /** Target grade level (falls back to the student's own grade in the event). */
  grade?: number;
}

export const GAME_SKILL_MAP: Partial<Record<MiniGameType, GameSkillMeta>> = {
  [MiniGameType.CUTTING_PIZZA]: { skill: 'add-subtract-fractions', grade: 4 },
  [MiniGameType.VAULT_CRACKER]: { skill: 'percent-of-quantity', grade: 6 },
};
